import { render, staticRenderFns } from "./RightBlock.vue?vue&type=template&id=0ed07ae8&scoped=true"
import script from "./RightBlock.vue?vue&type=script&lang=js"
export * from "./RightBlock.vue?vue&type=script&lang=js"
import style0 from "./RightBlock.vue?vue&type=style&index=0&id=0ed07ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed07ae8",
  null
  
)

export default component.exports